<template>
	<div class="cbs-label-content">
		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP">
			{{ localValue.description && localValue.description.value }}
		</div>
		<div>{{ localLabelAttributeValue }}</div>
		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM">
			{{ localValue.description && localValue.description.value }}
		</div>
	</div>
</template>

<script>
import CbsHint from "@/components/cbs-hint/CbsHint.vue";

export default {
	name: "LabelContent",
	components: {
		CbsHint
	},
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("children") &&
				prop.hasOwnProperty("attributes") &&
				prop.hasOwnProperty("is_optional") &&
				prop.hasOwnProperty("description")
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localAttributesValue() {
			const attributesValue = typeof this.localValue.attributes === "string" ? JSON.parse(this.localValue.attributes) : this.localValue.attributes;
			return attributesValue;
		},
		localLabelAttributeValue() {
			return this.localAttributesValue.value;
		}
	}
};
</script>

<style></style>
